import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }


const __default__ = {
  name: 'Finder'
}

import { ref, onActivated, onDeactivated, nextTick } from 'vue'
import useFinder from './useFinder'
import type {
  Action,
  FileConfig,
  Path,
  TabsConfig,
  FeatureConfig,
  FinderResponse
} from './types'

interface Props {
  action?: Action
  file?: FileConfig
  mode?: 'multi' | 'single' | 'dir'
  path?: Path
  featrues?: FeatureConfig | string[]
  tabs?: TabsConfig | string[]
  okText?: string
  committing?: boolean
  cancelText?: string
  transfer?: { userId: number; companyId: number }
}

/**
 * @description 暂不支持把类型抽出去，若支持，则直接传 Omit<Attributes, 'dw'>
 * @link https://github.com/vuejs/core/issues/4294
 */

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    action: null,
    file: null,
    mode: null,
    path: null,
    featrues: null,
    tabs: null,
    okText: null,
    committing: { type: Boolean },
    cancelText: null,
    transfer: null
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'confirm', response: FinderResponse): void
  (e: 'cancel', response: FinderResponse): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  action?: Action
  file?: FileConfig
  mode?: 'multi' | 'single' | 'dir'
  path?: Path
  featrues?: FeatureConfig | string[]
  tabs?: TabsConfig | string[]
  okText?: string
  committing?: boolean
  cancelText?: string
  transfer?: { userId: number; companyId: number }
}




const confirm = (response: FinderResponse) => {
  emit('confirm', response)
}

const cancel = (response: FinderResponse) => {
  emit('cancel', response)
}

const finderRef = ref<HTMLDivElement | null>(null)
const finder = useFinder({
  container: finderRef,
  handlers: { confirm, cancel }
})
const toggleFlag = ref(false)

const mountFinder = () => {
  finder.open({
    ...props,
    dw: {
      _from: 'test',
      _function: 'test'
    }
  })
}

// finder 无法真的销毁，只好这样了，有点恶心
const forceRefresh = async () => {
  finder.close()
  toggleFlag.value = !toggleFlag.value
  await nextTick()
  mountFinder()
}

/**
 * vue-finder 如果有多个实例，它们的状态是共享的，连同个事件都会触发多次
 * 若实例被缓存，则有多个实例，则需在适当时机内暂时销毁与重新挂载
 */
onActivated(() => {
  forceRefresh()
})

onDeactivated(() => {
  finder.close()
})

expose({ forceRefresh })

return (_ctx: any,_cache: any) => {
  return (toggleFlag.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          ref_key: "finderRef",
          ref: finderRef
        }, null, 512)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          ref_key: "finderRef",
          ref: finderRef
        }, null, 512)
      ]))
}
}

})